module.exports = __webpack_public_path__ + "static/media/Warning-Icon.4d84ab1e.svg";